export const overflowScrollTop = () => {
	scrollTo(0, 0)
	// document.body.style.setProperty("overflow", "hidden", "important"); //TODO: Revisar con anibal esta jodiendo el scroll de la aplicacion
}

export const overflowAutoScrollTop = () => {
	scrollTo(0, 0)
	// document.body.style.setProperty('overflow', 'auto', 'important')
}
